import { Component, OnInit, AfterViewInit, AfterContentChecked } from '@angular/core';
import { Product } from '../../libs/proto/shop_pb';
import { Router } from '@angular/router';
import { GrpcProductLibService } from '../../service/grpc/product/grpc-product-lib.service';
import { UserLibService } from '../../service/user/user-lib.service';
import { GrpcLibService } from '../../service/grpc/grpc-lib.service';
import { of } from 'rxjs';
import { StorageLibService } from '../../service/storage/storage-lib.service';
import { GrpcShopLibService } from '../../service/grpc/shop/grpc-shop-lib.service';
import { desktopMode } from '../../config/type';
import { DeviceLibService } from 'src/app/service/device/device-lib.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.sass']
})
export class ProductsComponent implements OnInit, AfterContentChecked {

  products$: Promise<Product[]>;
  defaultCollapse: string;
  onceScroll = false;

  landscapeEvt = window.matchMedia('(orientation: landscape)');
  isLandscape = false;

  menuType = 0;

  constructor(
    private route: Router,
    private grpcProductLib: GrpcProductLibService,
    private grpcShopLib: GrpcShopLibService,
    private userLib: UserLibService,
    private storeLib: StorageLibService,
    private detector: DeviceLibService,
  ) { }

  isCollapsed(c: string) {
    if (this.defaultCollapse) { return this.defaultCollapse === 'y'; }
    return this.userLib.Data.producstPage?.collapsed?.indexOf(c) >= 0;
  }

  ngOnInit(): void {

    this.grpcShopLib.getShopSettings({
      Offline: this.storeLib.cache.shopSetting || false,
    }).then( s => {
      if (this.userLib.Data.producstPage?.collapsed) {

      } else {
        this.defaultCollapse = s.getDefaultcollapse() ? 'y' : 'n';
      }

      this.getProducts();
    }).catch( (e: Error) => {
      if (e.message === GrpcLibService.ERR_SIGIN) {

        this.userLib.clear();
        this.route.navigateByUrl('/login');
        return;
      }
      // return to complete
      return of([]).toPromise();
    });

    this.isLandscape = this.detector.orientation === 'landscape';
    this.menuType = this.getmenuType();
    this.landscapeEvt.addEventListener('change', ev => {
      this.isLandscape = this.landscapeEvt.matches;
      this.menuType = this.getmenuType();
    });
  }

  checkVisible(elm: HTMLElement) {
    if (!elm) { return true; }
    const rect = elm.getBoundingClientRect();
    const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  }

  private scrollToPrev() {
    const c = document.getElementById(this.userLib.Data.producstPage?.id);
    if (this.checkVisible(c)) { return; }

    c?.scrollIntoView();
  }

  ngAfterContentChecked() {
    if (this.onceScroll) { return; }

    this.scrollToPrev();
  }

  private getProducts() {
    if (this.storeLib.get('product-s')) {
        this.storeLib.set('product-s', null);
        this.storeLib.cache.product = false;
    }
    this.products$ = this.grpcProductLib.getProducts({
      Offline: this.storeLib.cache.product || false,
    }).then( pp => {
      if (this.defaultCollapse === 'y') {
        for (const p of pp) {
          this.expanded(p.getCategoryid(), 2);
        }
        this.defaultCollapse = undefined;
      }
      return of(pp).toPromise();
    }).catch( (e: Error) => {
      if (e.message === GrpcLibService.ERR_SIGIN) {

        this.userLib.clear();
        this.route.navigateByUrl('/login');
        return;
      }
      // return to complete
      return of([]).toPromise();
    });
  }

  open(id: string){
    this.route.navigate(['/product', id]);
  }

  get cartBadge() {
    return this.storeLib.get('cart-badge');
  }
  clearScrollFlag() {
    this.onceScroll = true;
  }
  expanded(id: string, t: number){
    if (t !== 2) { this.onceScroll = true; }
    if (this.userLib.Data.producstPage === undefined) {
      this.userLib.Data.producstPage = {};
    }
    if (this.userLib.Data.producstPage.collapsed === undefined ){
      this.userLib.Data.producstPage.collapsed = [];
    }
    const ii = this.userLib.Data.producstPage?.collapsed.indexOf(id);
    if (t === 1) {
       this.userLib.Data.producstPage?.collapsed.splice(ii, 1);
    } else {
      if (ii === -1) {
        this.userLib.Data.producstPage?.collapsed.push(
        id
        );
      }
    }
  }

  /**
   * menu type
   * - 0 = list
   * - 1 = box with image (2 cols)
   * - 2 = box with image (4 cols)
   */
   getmenuType() {
    // if not mobile, return default mobile
    if (!this.detector.isMobile()) {
      // if desktop mode = 3, force to use photo menu
      if (+desktopMode === 3) { return 1; }
      // if desktop mode = 4, force to use photo menu4
      if (+desktopMode === 4)  {
        if (this.isLandscape) { return 2;  }
        return 1;
      }

      return 0;
    }

    return this.userLib.Data.token?.getCustomer().getMobilemenutype();
  }
 }
